export const table = {
  primaryData: [
    { title: "ID", value: "id", type: "configue" },
    {
        title:"Entity Name",
        value:"entityName",
        type:"configue"
    },
    {
        title:"Entity Type",
        value:"entityType",
        type:"configue"
    },
    {
        title:"Entity Value",
        value:"entityValue",
        type:"configue"
    },
    {
        title:"Joined At",
        value:"joinedAt",
        type:"configue"
    },
    {
        title:"Left At",
        value:"leftAt",
        type:"configue"
    },
    {
        title:"Time Spent (in seconds)",
        value:"timeSpentInSeconds",
        type:"configue"
    },
    {
        title:"Has Attended",
        value:"hasAttended",
        type:"configue"
    },
    {
        title:"Is Active",
        value:"isActive",
        type:"configue"
    },

  ],
  secondaryData: [

    {
        title:"Created At",
        value:"createdAt",
        type:"configue"
    },
    {
        title:"Updated At",
        value:"updatedAt",
        type:"configue",
        name:"updatedAt"
    },
    {
        title:"Created By",
        value:"createdByName",
        type:"configue"
    },
    {
        title:"Updated By",
        value:"updatedByName",
        type:"configue",
        name:"updatedByName"
    },
  ],
};


